import { Anchor } from '@klv/atoms/anchor';
import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import styled, { css } from 'styled-components';

export const TopicIcon = styled(Icon)`
  flex-shrink: 0;
`;

export const TopicName = styled(Typography)``;

const selectedState = css`
  ${({ theme }) => `
    background: ${theme.topicsMenu.selected.background};
    border-radius: 0.875rem;
    color: ${theme.topicsMenu.selected.color};
    div{
      color: ${theme.topicsMenu.selected.color};
      font-weight: 500;
    }
  `};
`;

const hover = css`
  ${({ theme }) => `
    background: ${theme.topicsMenu.hover.background};
    border-radius: 0.875rem;
    color: ${theme.topicsMenu.hover.color};
    div {
      color: ${theme.topicsMenu.hover.color};
    }
  `};
`;

export const StyledTopicsMenuItem = styled(Anchor)<{ selected: boolean; }>`
  appearance: none;
  border: none;
  outline: none;
  width: 100%;
  border: 2px transparent solid;
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 1.2rem;
  padding: 2.4rem;
  text-align: left;
  text-decoration: none;

  ${({ selected, theme }) => css`
    background: ${theme.topicsMenu.default.background};
    color: ${theme.topicsMenu.default.color};

    ${selected ? selectedState : ''}

    :hover {
      ${hover}
    }

    :focus-visible {
      outline: none;
      border-radius: 0.875rem;
      outline: 1px dashed ${theme.colors.charcoal};
    }

  `}

`;
